import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { NftService } from '../services/nft.service';
import { Platform } from '@ionic/angular';



@Injectable({
    providedIn: 'root'
})
export class WCGuard implements CanActivate {
    constructor(private router: Router,
        private nftService: NftService,
        private platform: Platform,) { }

    /**
     *
     * @author Neil C
     * @param next 
     * @param state 
     * @returns boolean
     */
    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

        const bridge = next.queryParamMap.get('bridge') || null;
        if (bridge) {

            const connector_uri = this.nftService.connector.uri || null;

            if (connector_uri) {
                window.open(connector_uri, '_blank'); // issue to resolve wc url which appends to the current route in ionic
            }


            return false;
        }



        return true;
    }
}
